import { render, staticRenderFns } from "./EditPropertyComponent.vue?vue&type=template&id=62d79367&"
import script from "./EditPropertyComponent.vue?vue&type=script&lang=js&"
export * from "./EditPropertyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports